// extracted by mini-css-extract-plugin
module.exports = {"overview":"Dashboard_overview__w5h4u","stats":"Dashboard_stats__2OQbX"};